"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var inversify_react_1 = require("inversify-react");
var QuoteCurrencyFormatter_1 = __importDefault(require("Utils/QuoteCurrencyFormatter"));
var QuoteComponents_1 = require("./QuoteComponents");
var QuoteItemStore_1 = require("QuoteV2/Stores/QuoteItemStore");
var classnames_1 = __importDefault(require("classnames"));
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var QuoteViewStore_1 = require("QuoteV2/Stores/QuoteViewStore");
var Recurrence_1 = require("@CommonFrontendBackend/QuoteV2/Recurrence");
var QuoteSelectButton_1 = __importDefault(require("./QuoteSelectButton"));
var DiscountPill_1 = __importStar(require("./DiscountPill"));
var Discount_service_1 = __importDefault(require("@CommonFrontendBackend/Discount/Discount.service"));
var ItemQuantity_1 = require("Public/Widgets/QuoteV2/ItemQuantity");
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var mobx_1 = require("mobx");
var QuoteBlockStore_1 = __importDefault(require("QuoteV2/Stores/QuoteBlockStore"));
var VariableStore_1 = __importDefault(require("QuoteV2/Stores/VariableStore"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var MaybeWrap_1 = __importDefault(require("Utils/MaybeWrap"));
var friendlyFilters_1 = require("./friendlyFilters");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var ProductStaticWellKnownMapping_1 = require("@CommonFrontendBackend/QuoteV2/ProductStaticWellKnownMapping");
var c = (0, BemBuilder_1.default)("plan-card");
var PlanCard = (function (_super) {
    __extends(PlanCard, _super);
    function PlanCard(props) {
        var _this = _super.call(this, props) || this;
        _this.cardElement = react_1.default.createRef();
        _this.specularElement = react_1.default.createRef();
        _this.cardHovered = false;
        _this.menuOpen = false;
        _this.pricePopoverOpen = false;
        _this.isInViewport = false;
        _this.toggleSelection = function (event) {
            event.stopPropagation();
            var _a = _this.props, item = _a.item, section = _a.section;
            if ((0, QuoteItemStore_1.supportsInteractivePricing)(item)) {
                _this.quote.setItemSelection(section, item, !item.isOptionalSelected);
            }
        };
        _this.followMouseMovement = function (event) {
            if (_this.cardElement.current && _this.specularElement.current) {
                if (_this.hasCardStylingDisabled()) {
                    _this.cardElement.current.style.transform = "none";
                    _this.specularElement.current.style.backgroundImage = "none";
                    return;
                }
                var rect = _this.cardElement.current.getBoundingClientRect();
                var sensitivity = 50;
                var cursorPosition = { x: event.clientX, y: event.clientY };
                var centerY = cursorPosition.y - (rect.y + rect.height / 2);
                var centerX = cursorPosition.x - (rect.x + rect.width / 2);
                var angleX = centerX / sensitivity;
                var angleY = -centerY / sensitivity;
                var theta = Math.atan2(-centerY, -centerX);
                var ang = theta * (180 / Math.PI) - 90;
                var angle = ang < 0 ? ang + 360 : ang;
                _this.cardElement.current.style.transform = "translateZ(0) rotateY(".concat(angleX, "deg) rotateX(").concat(angleY, "deg)");
                _this.specularElement.current.style.backgroundImage = "linear-gradient(".concat(angle, "deg, rgba(230, 230, 230, 0.3) 0%, transparent 80%)");
            }
        };
        _this.handleCardIntersection = function (_a) {
            var _b = __read(_a, 1), entry = _b[0];
            _this.isInViewport = entry.isIntersecting;
        };
        if (typeof window !== "undefined" && "IntersectionObserver" in window) {
            _this.cardIntersectionObserver = new IntersectionObserver(_this.handleCardIntersection);
        }
        return _this;
    }
    PlanCard.prototype.componentDidMount = function () {
        var _this = this;
        this.isRecommendedReactionDisposer = (0, mobx_1.reaction)(function () { return _this.isRecommended; }, function (isRecommended) {
            if (isRecommended) {
                if (_this.cardIntersectionObserver && _this.cardElement.current) {
                    _this.cardIntersectionObserver.observe(_this.cardElement.current);
                }
                else {
                    _this.isInViewport = true;
                }
            }
            else {
                if (_this.cardIntersectionObserver) {
                    _this.cardIntersectionObserver.disconnect();
                }
                else {
                    _this.isInViewport = false;
                }
            }
        }, { fireImmediately: true });
        this.shouldFollowMouseReactionDisposer = (0, mobx_1.reaction)(function () { return _this.shouldFollowMouse; }, function (shouldFollowMouse) {
            if (shouldFollowMouse) {
                document.addEventListener("mousemove", _this.followMouseMovement);
            }
            else {
                document.removeEventListener("mousemove", _this.followMouseMovement);
                if (_this.cardElement.current) {
                    if (_this.hasCardStylingDisabled()) {
                        _this.cardElement.current.style.transform = "none";
                    }
                    else {
                        _this.cardElement.current.style.transform = "translateZ(0) rotateY(0) rotateX(0)";
                    }
                }
            }
        }, { fireImmediately: true });
    };
    PlanCard.prototype.componentWillUnmount = function () {
        var _a, _b, _c;
        document.removeEventListener("mousemove", this.followMouseMovement);
        (_a = this.shouldFollowMouseReactionDisposer) === null || _a === void 0 ? void 0 : _a.call(this);
        (_b = this.cardIntersectionObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
        (_c = this.isRecommendedReactionDisposer) === null || _c === void 0 ? void 0 : _c.call(this);
    };
    Object.defineProperty(PlanCard.prototype, "shouldFollowMouse", {
        get: function () {
            return (this.isRecommended &&
                this.isInViewport &&
                !this.shouldBeDeemphasised &&
                !this.cardHovered &&
                !this.menuOpen &&
                !this.pricePopoverOpen);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanCard.prototype, "isRecommended", {
        get: function () {
            var item = this.props.item;
            return item instanceof QuoteItemStore_1.QuotePricedItemStore && item.isRecommended;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanCard.prototype, "shouldBeDeemphasised", {
        get: function () {
            var _a = this.props, item = _a.item, section = _a.section;
            if ((0, QuoteItemStore_1.supportsInteractivePricing)(item) && item.isOptional) {
                var isSelected = item.isOptionalSelected;
                var hasSelectedSibling = !!section.items.find(function (sectionItem) {
                    return sectionItem !== item &&
                        (0, QuoteItemStore_1.supportsInteractivePricing)(sectionItem) &&
                        sectionItem.isOptional &&
                        sectionItem.isOptionalSelected;
                });
                return !isSelected && hasSelectedSibling;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    PlanCard.prototype.recurrencyLabel = function (item) {
        var _a, _b;
        if (item instanceof QuoteItemStore_1.QuoteProductItemStore) {
            if (ProductStaticWellKnownMapping_1.ProductStaticWellKnownMapping.supportsMappedProductField(Types_1.ProductMappedField.BillingFrequency, (_a = item.token.substitutionToken) === null || _a === void 0 ? void 0 : _a.id)) {
                return "p.".concat(ProductStaticWellKnownMapping_1.ProductStaticWellKnownMapping.getMappedProductFieldName(Types_1.ProductMappedField.BillingFrequency, (_b = item.token.substitutionToken) === null || _b === void 0 ? void 0 : _b.id));
            }
            return "";
        }
        if ((0, Types_1.isRecurringSchedule)(item.billingSchedule)) {
            var perLabel = this.quoteViewStore.getLabel((0, Recurrence_1.mapRecurringFrequencyToPerLabel)(item.billingSchedule.frequency));
            return " / ".concat(perLabel);
        }
        return "";
    };
    PlanCard.prototype.hasCardStylingDisabled = function () {
        if (this.cardElement.current) {
            return window.getComputedStyle(this.cardElement.current, ":before")["content"] === '"disabled"';
        }
        return false;
    };
    PlanCard.prototype.renderPrice = function (item) {
        var _this = this;
        var _a = this.props, onChangeBillingSchedule = _a.onChangeBillingSchedule, allowDiscountPill = _a.allowDiscountPill;
        var price = (react_1.default.createElement("span", { className: c("price") },
            item instanceof QuoteItemStore_1.QuotePricedItemStore &&
                this.quoteCurrencyFormatter.formatWithUserDecimalPreference(item.total.preTax),
            item instanceof QuoteItemStore_1.QuoteProductItemStore && "plan.total"));
        var variablePlaceholder = react_1.default.createElement("span", { className: c("variable-placeholder") }, "Find a variable");
        var showVariablePlaceholder = this.quoteViewStore.showPlaceholders &&
            item instanceof QuoteItemStore_1.QuoteVariableItemStore &&
            (!item.rate || !this.variableStore.getVariable(item.rate));
        var priceNode = (react_1.default.createElement("div", { className: c("price-container") },
            item instanceof QuoteItemStore_1.QuotePricedItemStore && (0, DiscountPill_1.shouldShowDiscount)(item.discount, this.discountService) && (react_1.default.createElement("div", { className: c("discount-container") },
                react_1.default.createElement("span", { className: c("pre-discount"), "aria-label": "Price before discount" }, this.quoteCurrencyFormatter.formatWithUserDecimalPreference(item.total.preDiscount)),
                allowDiscountPill && react_1.default.createElement(DiscountPill_1.default, { discount: item.discount, showSavedDiscountName: false }))),
            showVariablePlaceholder ? variablePlaceholder : price,
            this.recurrencyLabel(item) && react_1.default.createElement("span", { className: c("recurrence") }, this.recurrencyLabel(item))));
        if (item instanceof QuoteItemStore_1.QuotePricedItemStore && this.quoteComponents.PlanCardPricePopover) {
            return (react_1.default.createElement(this.quoteComponents.PlanCardPricePopover, { item: this.props.item, onOpenToggle: function (isOpen) {
                    _this.pricePopoverOpen = isOpen;
                }, onChangeBillingSchedule: function (schedule) { return onChangeBillingSchedule(schedule); } }, priceNode));
        }
        return priceNode;
    };
    PlanCard.prototype.render = function () {
        var _this = this;
        var _a = this.props, item = _a.item, section = _a.section, rest = __rest(_a, ["item", "section"]);
        var entireCardSelectable = this.quoteViewStore.planCardSelectArea === QuoteViewStore_1.PlanCardSelectArea.EntireCard &&
            (0, QuoteItemStore_1.supportsInteractivePricing)(item) &&
            item.isOptional &&
            this.quoteViewStore.isInteractive;
        var fade = this.quoteViewStore.hideMode === QuoteViewStore_1.QuoteHideMode.Fade;
        var invisible = this.quoteViewStore.hideMode === QuoteViewStore_1.QuoteHideMode.Invisible;
        var maybeWrapWithQuoteProductContext = function (children) {
            return item instanceof QuoteItemStore_1.QuoteProductItemStore && !!_this.quoteComponents.QuoteProductContext ? (react_1.default.createElement(_this.quoteComponents.QuoteProductContext, { token: item.token }, children)) : (children);
        };
        return maybeWrapWithQuoteProductContext(react_1.default.createElement(this.quoteComponents.DragDropHandler, { section: section, item: item, direction: QuoteComponents_1.DragDropHandlerDirection.Horizontal }, function (_a) {
            var dragHandlers = _a.dragHandlers, indicatorPosition = _a.indicatorPosition, isDraggingProductListToken = _a.isDraggingProductListToken;
            return (react_1.default.createElement(mobx_react_1.Observer, null, function () {
                var _a, _b, _c;
                return (react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)(c(), "user-font", (_a = {},
                        _a[c("", "deemphasised")] = _this.shouldBeDeemphasised,
                        _a[c("", "hovered")] = _this.cardHovered,
                        _a[c("", "recommended")] = _this.isRecommended,
                        _a[c("", "menu-open")] = _this.menuOpen,
                        _a[c("", "price-popover-open")] = _this.pricePopoverOpen,
                        _a[c("", "product-item")] = item instanceof QuoteItemStore_1.QuoteProductItemStore,
                        _a[c("drop-indicator")] = !!indicatorPosition,
                        _a[c("drop-indicator", indicatorPosition)] = !!indicatorPosition,
                        _a[c("drop-indicator", "is-dragging")] = isDraggingProductListToken,
                        _a)) }, dragHandlers),
                    react_1.default.createElement("div", { className: c("card-element-container") },
                        react_1.default.createElement("div", { className: c("card-element-wrapper") },
                            react_1.default.createElement("div", { "data-qwilr-component": "quote-plan-card", className: (0, classnames_1.default)(c("card-element"), (_b = {},
                                    _b[c("card-element", "entire-card-selectable")] = entireCardSelectable,
                                    _b)), ref: _this.cardElement, onClick: entireCardSelectable ? _this.toggleSelection : undefined, onMouseEnter: function () {
                                    _this.cardHovered = true;
                                }, onMouseLeave: function () {
                                    _this.cardHovered = false;
                                } },
                                react_1.default.createElement("div", { className: c("card-content") },
                                    _this.quoteComponents.PlanCardMenu && (react_1.default.createElement("div", { className: c("card-action") },
                                        react_1.default.createElement(_this.quoteComponents.PlanCardMenu, { section: section, item: item, onMenuOpened: function () {
                                                _this.menuOpen = true;
                                            }, onMenuClosed: function () {
                                                _this.menuOpen = false;
                                            } }))),
                                    _this.isRecommended && (react_1.default.createElement("div", { className: c("card-recommended") }, _this.quoteViewStore.getLabel(Types_1.QuoteLabel.Recommended))),
                                    react_1.default.createElement("div", { className: c("card-face") },
                                        item instanceof QuoteItemStore_1.QuoteProductItemStore && (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("product-filter-wrapper"), "qwilr-font") },
                                            react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (content) {
                                                    return _this.quoteComponents.QuoteProductFilter ? (react_1.default.createElement(_this.quoteComponents.QuoteProductFilter, { item: item }, content)) : undefined;
                                                } },
                                                react_1.default.createElement(icons_1.Tokens, { size: icons_1.IconSize.Small }),
                                                react_1.default.createElement(kaleidoscope_2.TruncatedText, { className: c("product-filter-label") }, (0, friendlyFilters_1.stringifyFilter)(item))))),
                                        react_1.default.createElement("div", { className: c("card-description") },
                                            react_1.default.createElement(_this.quoteComponents.PlanCardDescription, { "data-qwilr-component": "plan-card-description", content: item.description })),
                                        (item instanceof QuoteItemStore_1.QuotePricedItemStore || item instanceof QuoteItemStore_1.QuoteProductItemStore) && (react_1.default.createElement(react_1.default.Fragment, null,
                                            _this.renderPrice(item),
                                            react_1.default.createElement("div", { className: c("card-quantity-row"), "data-qwilr-component": "plan-card-quantity-row" },
                                                react_1.default.createElement("div", { className: (0, classnames_1.default)(c("card-quantity-wrapper")) },
                                                    react_1.default.createElement("div", { className: (0, classnames_1.default)(c("card-quantity"), (_c = {},
                                                            _c["".concat(c("card-quantity", "fade"))] = fade && !section.showItemQuantity,
                                                            _c["".concat(c("card-quantity", "invisible"))] = invisible && !section.showItemQuantity,
                                                            _c)) },
                                                        react_1.default.createElement(_this.quoteComponents.ItemQuantity, { "data-qwilr-component": "plan-card-quantity", section: section, item: item, width: ItemQuantity_1.ItemQuantityWidth.Dynamic, syncQuantity: section.itemSingleSelect })),
                                                    _this.quoteComponents.ColumnVisibilityButton && (react_1.default.createElement("div", { className: c("card-quantity-visibility-button") },
                                                        react_1.default.createElement(_this.quoteComponents.ColumnVisibilityButton, { size: kaleidoscope_1.ButtonSize.Small, toggle: function () {
                                                                var next = !section.showItemQuantity;
                                                                section.showItemQuantity = next;
                                                                _this.quoteTelemetry.trackPlanCardSectionShowQuantityChanged(next);
                                                            }, tooltip: section.showItemQuantity ? "Hide quantity" : "Show quantity", disabled: false }))))),
                                            item.isOptional && (react_1.default.createElement(QuoteSelectButton_1.default, { selected: item.isOptionalSelected, onClick: function (event) {
                                                    _this.toggleSelection(event);
                                                    _this.quoteTelemetry.trackPricingPlanCardSelected();
                                                } }))))),
                                    _this.isRecommended && react_1.default.createElement("div", { className: c("specular"), ref: _this.specularElement }),
                                    _this.quoteComponents.PlanCardAddMenu && (react_1.default.createElement("div", { className: c("adder") },
                                        react_1.default.createElement(_this.quoteComponents.PlanCardAddMenu, { section: section, item: item })))))),
                        (item instanceof QuoteItemStore_1.QuotePricedItemStore || item instanceof QuoteItemStore_1.QuoteProductItemStore) &&
                            section.showFeatureList && (react_1.default.createElement("div", { className: c("feature-list") },
                            react_1.default.createElement(_this.quoteComponents.PlanCardFeatureList, { content: item.featureList }))),
                        _this.quoteComponents.DiscountNotice && react_1.default.createElement(_this.quoteComponents.DiscountNotice, { item: item }))));
            }));
        }));
    };
    var _a, _b, _c, _d, _e, _f, _g, _h;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof QuoteBlockStore_1.default !== "undefined" && QuoteBlockStore_1.default) === "function" ? _a : Object)
    ], PlanCard.prototype, "quote", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("quoteCurrencyFormatter"),
        __metadata("design:type", typeof (_b = typeof QuoteCurrencyFormatter_1.default !== "undefined" && QuoteCurrencyFormatter_1.default) === "function" ? _b : Object)
    ], PlanCard.prototype, "quoteCurrencyFormatter", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteComponents_1.QuoteComponents.$),
        __metadata("design:type", typeof (_c = typeof QuoteComponents_1.QuoteComponents !== "undefined" && QuoteComponents_1.QuoteComponents) === "function" ? _c : Object)
    ], PlanCard.prototype, "quoteComponents", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteViewStore_1.QuoteViewStore.$),
        __metadata("design:type", typeof (_d = typeof QuoteViewStore_1.QuoteViewStore !== "undefined" && QuoteViewStore_1.QuoteViewStore) === "function" ? _d : Object)
    ], PlanCard.prototype, "quoteViewStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("discountService"),
        __metadata("design:type", typeof (_e = typeof Discount_service_1.default !== "undefined" && Discount_service_1.default) === "function" ? _e : Object)
    ], PlanCard.prototype, "discountService", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_f = typeof QuoteTelemetry_1.QuoteTelemetry !== "undefined" && QuoteTelemetry_1.QuoteTelemetry) === "function" ? _f : Object)
    ], PlanCard.prototype, "quoteTelemetry", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_g = typeof VariableStore_1.default !== "undefined" && VariableStore_1.default) === "function" ? _g : Object)
    ], PlanCard.prototype, "variableStore", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], PlanCard.prototype, "cardHovered", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], PlanCard.prototype, "menuOpen", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], PlanCard.prototype, "pricePopoverOpen", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], PlanCard.prototype, "isInViewport", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], PlanCard.prototype, "shouldFollowMouse", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], PlanCard.prototype, "isRecommended", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], PlanCard.prototype, "shouldBeDeemphasised", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PlanCard.prototype, "toggleSelection", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", typeof (_h = typeof IntersectionObserverCallback !== "undefined" && IntersectionObserverCallback) === "function" ? _h : Object)
    ], PlanCard.prototype, "handleCardIntersection", void 0);
    PlanCard = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], PlanCard);
    return PlanCard;
}(react_1.default.Component));
exports.default = PlanCard;
